import {
  LayoutDashboard, Lightbulb, LayoutGrid, FileText, Instagram, Youtube, Megaphone,
  CalendarDays, ClipboardList, CalendarClock, CalendarHeart,
  Library, BookOpen, FileAudio, MessagesSquare, Image,
  CheckCircle2, ShieldCheck, Stamp, Inbox,
  BarChart3, TrendingUp, Hash, Sparkles,
  Users, Activity, FileBarChart, Gauge,
  Settings, Building2, KeyRound, Workflow, ListChecks, Bell, Bot, Plug, Languages, Palette, Scale, HeartPulse,
} from "lucide-react";

// ready: routes implemented in Release 1. others render ComingSoon.
export const NAV = [
  {
    group: null,
    items: [{ label: "Home", to: "/", icon: LayoutDashboard, ready: true, end: true }],
  },
  {
    group: "Content",
    items: [
      { label: "Ideas", to: "/content/ideas", icon: Lightbulb, release: 2 },
      { label: "Master Topics", to: "/content/topics", icon: LayoutGrid, release: 2 },
      { label: "Blogs", to: "/content/blogs", icon: FileText, release: 3 },
      { label: "Instagram", to: "/content/instagram", icon: Instagram, release: 4 },
      { label: "YouTube", to: "/content/youtube", icon: Youtube, release: 4 },
      { label: "Campaigns", to: "/content/campaigns", icon: Megaphone, release: 4 },
    ],
  },
  {
    group: "Planning",
    items: [
      { label: "Content Calendar", to: "/planning/calendar", icon: CalendarDays, release: 4 },
      { label: "Assignments", to: "/planning/assignments", icon: ClipboardList, release: 2 },
      { label: "Upcoming Content", to: "/planning/upcoming", icon: CalendarClock, release: 4 },
      { label: "Important Dates", to: "/planning/dates", icon: CalendarHeart, release: 4 },
    ],
  },
  {
    group: "Knowledge",
    items: [
      { label: "Source Library", to: "/knowledge/sources", icon: Library, release: 3 },
      { label: "Vijayalakshmi Materials", to: "/knowledge/materials", icon: BookOpen, release: 6 },
      { label: "Transcripts", to: "/knowledge/transcripts", icon: FileAudio, release: 6 },
      { label: "Audience Questions", to: "/knowledge/questions", icon: MessagesSquare, release: 6 },
      { label: "Media Library", to: "/knowledge/media", icon: Image, release: 4 },
    ],
  },
  {
    group: "Reviews",
    items: [
      { label: "My Reviews", to: "/reviews/mine", icon: CheckCircle2, release: 2 },
      { label: "Authenticity Reviews", to: "/reviews/authenticity", icon: ShieldCheck, release: 3 },
      { label: "Final Approvals", to: "/reviews/approvals", icon: Stamp, release: 2 },
      { label: "Pending Items", to: "/reviews/pending", icon: Inbox, release: 2 },
    ],
  },
  {
    group: "Performance",
    items: [
      { label: "Overview", to: "/performance/overview", icon: BarChart3, release: 7 },
      { label: "Blogs", to: "/performance/blogs", icon: FileText, release: 7 },
      { label: "Instagram", to: "/performance/instagram", icon: Instagram, release: 7 },
      { label: "YouTube", to: "/performance/youtube", icon: Youtube, release: 7 },
      { label: "Topics", to: "/performance/topics", icon: TrendingUp, release: 7 },
      { label: "Hooks", to: "/performance/hooks", icon: Hash, release: 7 },
      { label: "Content Insights", to: "/performance/insights", icon: Sparkles, release: 7 },
    ],
  },
  {
    group: "Team",
    items: [
      { label: "Members", to: "/team/members", icon: Users, ready: true },
      { label: "Activity", to: "/team/activity", icon: Activity, ready: true },
      { label: "Daily Reports", to: "/team/reports", icon: FileBarChart, release: 5 },
      { label: "Workload", to: "/team/workload", icon: Gauge, release: 5 },
    ],
  },
  {
    group: "Reports",
    items: [
      { label: "Daily Reports", to: "/reports/daily", icon: FileBarChart, release: 5 },
      { label: "Weekly Reports", to: "/reports/weekly", icon: FileBarChart, release: 5 },
      { label: "Content Reports", to: "/reports/content", icon: FileText, release: 5 },
      { label: "Performance Reports", to: "/reports/performance", icon: BarChart3, release: 7 },
    ],
  },
  {
    group: "Settings",
    items: [
      { label: "Organisation", to: "/settings/organisation", icon: Building2, ready: true },
      { label: "Roles & Permissions", to: "/settings/roles", icon: KeyRound, ready: true },
      { label: "Report Recipients", to: "/settings/recipients", icon: Users, ready: true },
      { label: "Language & Labels", to: "/settings/language", icon: Languages, ready: true },
      { label: "Theme", to: "/settings/appearance", icon: Palette, ready: true },
      { label: "Integrations", to: "/settings/integrations", icon: Plug, ready: true },
      { label: "Workflow", to: "/settings/workflow", icon: Workflow, release: 2 },
      { label: "Checklists", to: "/settings/checklists", icon: ListChecks, release: 2 },
      { label: "Notifications", to: "/settings/notifications", icon: Bell, release: 5 },
      { label: "AI", to: "/settings/ai", icon: Bot, release: 6 },
      { label: "Review Rules", to: "/settings/review-rules", icon: Scale, release: 3 },
      { label: "System Health", to: "/settings/health", icon: HeartPulse, release: 5 },
    ],
  },
];

// flat lookup for ComingSoon titles
export const NAV_LOOKUP = NAV.flatMap((g) =>
  g.items.map((i) => ({ ...i, group: g.group }))
);
